// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import moment from 'moment';

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

import './components';

import Toasted from 'vue-toasted';
Vue.use(Toasted);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);


import {
  APP_URL
} from './constants/default.js';
import MediaLibrary from 'vue-medialibrary';
Vue.use(MediaLibrary, {
    API_URL: APP_URL
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js